/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import '@fontsource/oswald/200.css'
import '@fontsource/oswald/400.css'
import '@fontsource/baskervville/400-italic.css'
import '@fontsource-variable/archivo'

/**
 * Land new pages at the top.
 *
 * gatsby-source-wordpress enables gatsby-plugin-catch-links, so plain internal
 * <a> links (the footer's privacy/terms links, the WP-sourced footer menu) are
 * turned into client-side navigations rather than full page loads. Without an
 * explicit rule here Gatsby leaves the viewport where it was, so clicking a
 * footer link from the bottom of a long page opened the next page mid-content.
 */
export const shouldUpdateScroll = ({
  routerProps: { location },
  prevRouterProps,
  getSavedScrollPosition,
}) => {
  // Anchor links keep the default behaviour: scroll to the target element.
  if (location.hash) return true

  // Back/forward returns you to where you left off.
  if (location.action === `POP`) {
    return getSavedScrollPosition(location) || [0, 0]
  }

  // Staying on the same page (query-string changes such as filters or search)
  // shouldn't yank the viewport around.
  if (prevRouterProps?.location.pathname === location.pathname) return false

  return [0, 0]
}